var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconUnpin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 4945",
    d: "M8.82465 12.874L12.2776 16.327C12.2776 16.327 11.5148 13.6368 14.8878 10.2638C18.2608 6.89085 19.1909 6.81391 19.1909 6.81391L17.0417 4.65686",
    stroke: "#73757C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 302",
    d: "M8.93848 4.57507L16.7167 12.3532",
    stroke: "#73757C",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 4946",
    d: "M8.82414 12.8745L5.37115 9.42147C5.37115 9.42147 8.06134 10.1843 11.4343 6.81132C14.8072 3.43837 14.9522 2.5673 14.9522 2.5673L17.0415 4.65709",
    stroke: "#73757C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 45",
    d: "M8.82495 12.8748L4.36784 17.3319",
    stroke: "#73757C",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 303",
    d: "M11.4136 4.92859L17.0704 10.5854",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 304",
    d: "M9.29224 7.04993L14.9491 12.7068",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUnpin);
export default __webpack_public_path__ + "static/media/Icon_unpin.154dcdb11013a584e5d17be7ed6b8e38.svg";
export { ForwardRef as ReactComponent };